import { render, staticRenderFns } from "./SingpassMyInfo.vue?vue&type=template&id=6e56cbc6&"
import script from "./SingpassMyInfo.vue?vue&type=script&lang=js&"
export * from "./SingpassMyInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingpassMyInfo.vue?vue&type=style&index=0&id=6e56cbc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports